import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Shell from './pages/Shell';
import { isLoggedIn } from './services/api';
import './App.css';

function PrivateRoute({ children }) {
  return isLoggedIn() ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={isLoggedIn() ? <Navigate to="/" replace /> : <Login />} />
        <Route path="/*" element={<PrivateRoute><Shell /></PrivateRoute>} />
      </Routes>
    </BrowserRouter>
  );
}
